import { render } from "./EditApplicationPermissionsDialog.vue?vue&type=template&id=5638c574"
import script from "./EditApplicationPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./EditApplicationPermissionsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__